import { PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.oidcAuthority,
    redirectUrl: environment.redirectUri,
    clientId: 'auction-frontend',
    scope: 'openid profile bfg-data',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    postLoginRoute: '/oidc/callback',
    unauthorizedRoute: '/oidc/unauthorized',
  }
}
